export default __webpack_public_path__ + "static/media/VideoValidation_guide.01bcd885.png";